import axios from 'axios'
import session from 'vue-cookies'
const BASE_URL =  'https://api.bertiebets.com/prediction/'
//const BASE_URL =   'https://b4pssbgsg8.execute-api.us-east-1.amazonaws.com/prod/prediction/'
var key = session.get('bertiebets.admin.key')
export function getPrediction(raceId, report) {
  return new Promise ((resolve, reject) => {
    if (!report) report = false
    axios.get(BASE_URL + raceId + "?report=" + report, {headers:{'x-api-key' : key}})
    .then(response => {
      if (response.status === 200) {
        resolve(response.data)
      }else {
        reject(response.status)
      }
    })
    .catch (err => {
      reject(err)
    })
  })
}
